import { apiCall } from './api.service';

export const getDelegations = async (token, organisationId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/delegations`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const getDelegation = async (token, organisationId, delegationId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/delegations/${delegationId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const createDelegation = async (token, organisationId, delegationData) => {
    const method = 'post';
    const path = `api/v1/organisations/${organisationId}/delegations`;

    const response = await apiCall(method, delegationData, path, token);
    return response;
};

export const updateDelegation = async (token, organisationId, delegationId, delegationData) => {
    const method = 'put';
    const path = `api/v1/organisations/${organisationId}/delegations/${delegationId}`;

    const response = await apiCall(method, delegationData, path, token);
    return response;
};

export const deleteDelegation = async (token, organisationId, delegationId) => {
    const method = 'delete';
    const path = `api/v1/organisations/${organisationId}/delegations/${delegationId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};
